import { Action, createReducer, on } from '@ngrx/store';
import * as HubConnectionActions from 'src/app/root-store/hub-connection-store//hub-connection.actions';
import { HubConnectionState } from 'src/app/root-store/hub-connection-store/hub-connection.state';

const initialState: HubConnectionState = {
    isActive: false,
    error: null,
    isPerDiemActive: false,
    pdError: null,
    timecardError: null,
    isTimecardActive: false,
    isInvoiceActive: false,
    invoiceError: null,
    isReverseInvoiceActive: false,
    reverseInvoiceError: null,
    isComplianceActive: false,
    ComplianceError: null,
    isDocumentTypeBulkACStatusChangeNotifierActive: false,
    isDocumentTypeBulkACStatusChangeNotifierError: null
};

export function reducer(state: HubConnectionState, action: Action) {
    return createReducer(
        initialState,
        on(
            HubConnectionActions.connectToCoreHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isActive: true
            })
        ),
        on(
            HubConnectionActions.connectToCoreHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isActive: false,
                error: action.error
            })
        ),
        on(
            HubConnectionActions.disconnectFromCoreHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isActive: false
            })
        ),
        on(
            HubConnectionActions.disconnectFromCoreHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isActive: true,
                error: action.error
            })
        ),
        on(
            HubConnectionActions.connectToPdHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isPerDiemActive: true
            })
        ),
        on(
            HubConnectionActions.connectToPdHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isPerDiemActive: false,
                pdError: action.error
            })
        ),
        on(
            HubConnectionActions.disconnectFromPdHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isPerDiemActive: false
            })
        ),
        on(
            HubConnectionActions.disconnectFromPdHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isPerDiemActive: true,
                pdError: action.error
            })
        ),
        on(
            HubConnectionActions.connectToTimecardHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isTimecardActive: true
            })
        ),
        on(
            HubConnectionActions.connectToTimecardHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isTimecardActive: false,
                timecardError: action.error
            })
        ),
        on(
            HubConnectionActions.disconnectFromTimecardHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isTimecardActive: false
            })
        ),
        on(
            HubConnectionActions.disconnectFromTimecardHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isTimecardActive: true,
                timecardError: action.error
            })
        ),
        on(
            HubConnectionActions.connectToInvoiceHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isInvoiceActive: true
            })
        ),
        on(
            HubConnectionActions.connectToInvoiceHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isInvoiceActive: false,
                invoiceError: action.error
            })
        ),
        on(
            HubConnectionActions.disconnectFromInvoiceHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isInvoiceActive: false
            })
        ),
        on(
            HubConnectionActions.disconnectFromInvoiceHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isInvoiceActive: true,
                invoiceError: action.error
            })
        ),
        on(
            HubConnectionActions.connectToReverseInvoiceHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isReverseInvoiceActive: true
            })
        ),
        on(
            HubConnectionActions.connectToReverseInvoiceHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isReverseInvoiceActive: false,
                reverseInvoiceError: action.error
            })
        ),
        on(
            HubConnectionActions.disconnectFromReverseInvoiceHubSuccess,
            (state): HubConnectionState => ({
                ...state,
                isReverseInvoiceActive: false
            })
        ),
        on(
            HubConnectionActions.disconnectFromReverseInvoiceHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isReverseInvoiceActive: true,
                reverseInvoiceError: action.error
            })
        ),
        on(
            HubConnectionActions.connectToComplianceHubSuccess,
            (state, action): HubConnectionState => ({
                ...state,
                isComplianceActive: true
            })
        ),
        on(
            HubConnectionActions.connectToComplianceHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isComplianceActive: false,
                ComplianceError: action.error
            })
        ),
        on(
            HubConnectionActions.connectToDocumentTypeBulkACStatusChangeNotifierHubSuccess,
            (state, action): HubConnectionState => ({
                ...state,
                isDocumentTypeBulkACStatusChangeNotifierActive: true
            })
        ),
        on(
            HubConnectionActions.connectToDocumentTypeBulkACStatusChangeNotifierHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isDocumentTypeBulkACStatusChangeNotifierActive: false,
                isDocumentTypeBulkACStatusChangeNotifierError: action.error
            })
        ),
        on(
            HubConnectionActions.disconnectFromDocumentTypeBulkACStatusChangeNotifierHubSuccess,
            (state, action): HubConnectionState => ({
                ...state,
                isDocumentTypeBulkACStatusChangeNotifierActive: false
            })
        ),
        on(
            HubConnectionActions.disconnectFromDocumentTypeBulkACStatusChangeNotifierHubFailure,
            (state, action): HubConnectionState => ({
                ...state,
                isDocumentTypeBulkACStatusChangeNotifierError: action.error
            })
        )
    )(state, action);
}

export function hubConnectionReducer(state: HubConnectionState | undefined, action: Action) {
    return reducer(state, action);
}
